import * as c from '../../constants/engineering';
import * as f from '../../constants/filemanager';

export const defaultState = [];

const toolbar = (state = defaultState, action) => {
  switch (action.type) {
    case c.ENG_INIT:
      return action.data.engineering.toolbar || [];

    case c.ENG_SEND_WORK_AREA_SUCCESS:
    case f.FM_NEW_CONCEPT_SUCCESS:
    case f.FM_OPEN_REVISION_SUCCESS:
      return state.map((elem) => ({
        ...elem,
        ...action.result.toolbar.find((x) => elem.id === x.id),
      }));

    default:
      return state;
  }
};

export default toolbar;
